"use client";

const $$splitErrorComponentImporter = () => import('/home/runner/work/VideoServerGolang/VideoServerGolang/web_src/routes/actress.$name.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/VideoServerGolang/VideoServerGolang/web_src/routes/actress.$name.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import Spinner from "../Components/spinner.tsx";
import fetcher from "../lib/fetcher.ts";
export const Route = createFileRoute("/actress/$name")({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader: async ({
    params: {
      name
    }
  }) => await fetcher(`/api/actress/${name}`),
  pendingComponent: () => <Spinner fontSize={24} />,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});